import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Row } from 'antd';
import { Context } from './context';

import * as S from './styles';

export function TransferFilial({ init, initialTargetKeys }) {
  const { setFilialSelected, saveMigration } = useContext(Context);

  const [targetKeys, setTargetKeys] = useState(initialTargetKeys);
  const [initData, setInitData] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);

  const onChange = useCallback(nextTargetKeys => {
    setTargetKeys(nextTargetKeys);
  }, []);

  const onSelectChange = useCallback(
    (sourceSelectedKeys, targetSelectedKeys) => {
      setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    },
    []
  );

  useEffect(() => {
    setFilialSelected(targetKeys);
  }, [targetKeys]); //eslint-disable-line

  useEffect(() => {
    setTargetKeys(initialTargetKeys);
  }, [initialTargetKeys]);

  useEffect(() => {
    setInitData(init);
  }, [init]);

  return (
    <S.WrapperTransfer>
      <S.TransferCustom
        dataSource={initData}
        titles={['Filiais TMOV', 'Filiais TMOV']}
        locale={{
          itemUnit: 'Item',
          itemsUnit: 'Itens'
        }}
        targetKeys={targetKeys}
        selectedKeys={selectedKeys}
        onChange={onChange}
        onSelectChange={onSelectChange}
        render={item => item.title}
        filterOption={(input, option) =>
          option.title.toLowerCase().includes(input.toLowerCase())
        }
      />
      <Row
        justify="center"
        align="center"
        style={{
          marginTop: 36,
        }}
      >
        <S.StyledButton
          type="primary"
          htmlType="submit"
          onClick={() => saveMigration()}
        >
          Salvar
        </S.StyledButton>
      </Row>
    </S.WrapperTransfer>
  );
}
